/**
* Fund page manages the expansion panels (navigation) and the various fund components
*
* Created by Paul on 7/5/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// action import
import { ActionCreator } from '../../actions/'

// material-ui import
import { withStyles, makeStyles } from '@material-ui/styles';
import { createMuiTheme } from "@material-ui/core/styles";

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Badge from '@material-ui/core/Badge'

// components import
import FundOverview from '../../components/FundOverview/'
import FundActions from '../../components/FundActions/'
import FundMembers from '../../components/FundMembers/'
import FundContributions from '../../components/FundContributions/'
import FundReports from '../../components/FundReports/'
import FundBilling from '../../components/FundBilling/'
import DocumentsTable from '../../components/DocumentsTable/'

import FileBrowser from '../../components/FileBrowser/'

import { isEmpty } from '../../utility/utilities'

const styles = theme => ({
	root: {
		width: '100%',
	},
	heading: {
		fontSize: 16,
		flexBasis: '33.33%',
		flexShrink: 0,
		fontWeight: 500,
	},
	secondaryHeading: {
		fontSize: 15,
		color: 'rgba(0, 0, 0, 0.54)'
	},
})

class Fund extends Component {

	constructor(props) {
		super(props)
		this.state = { expanded: false }
	}

    componentDidMount() {
    	const {fundSummary, getFundSummary, getDocumentsData, getDocusignData} = this.props
    	const {member_id} = this.props.match.params

    	if (isEmpty(fundSummary)) {
			getFundSummary(member_id)
		}

		getDocumentsData(member_id)
		getDocusignData(member_id)
    }

	handleChange = panel => (event, isExpanded) => {
		this.setState({
        	expanded: isExpanded ? panel : false,
        })
	}

	render() {

		const { classes, documentListData, deleteDocument, fundSummary, getDocumentsData, fundsSummaryData, docusignDocuments } = this.props
		const { member_id } = this.props.match.params

		let actionCount = 0
		let overviewText = 'Overview'
		let isAgent = fundsSummaryData['administrator_type'].startsWith('agent-')

		if (!isEmpty(fundSummary)) {
			actionCount = parseInt(fundSummary.unmatched_business_events) + 
				parseInt(fundSummary.outstanding_corporate_action_count) + 
				parseInt(fundSummary.unmatched_cash_events)

			overviewText = (fundSummary.fund_name + ' ' + overviewText)
		}

		return (
			<div className="funds main-wrapper">
			
				<ExpansionPanel defaultExpanded>
					<ExpansionPanelSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="overview-content"
						id="overview-header"
					>
						<Typography className={ classes.heading }>{overviewText}</Typography>
					</ExpansionPanelSummary>

					<FundOverview member_id={member_id} />

				</ExpansionPanel>

			
				<ExpansionPanel expanded={this.state.expanded === 'actions'} onChange={this.handleChange('actions')}>
					<ExpansionPanelSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="actions-content"
						id="actions-header"
					>
					
					<Badge color="secondary" badgeContent={actionCount}>
                		<Typography className={ classes.heading }>Actions</Typography>
              		</Badge>

					</ExpansionPanelSummary>
					
					<FundActions member_id={member_id} />
					
				</ExpansionPanel>

			
				<ExpansionPanel expanded={this.state.expanded === 'members'} onChange={this.handleChange('members')}>
					<ExpansionPanelSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="members-content"
						id="members-header"
					>
						<Typography className={ classes.heading }>Members</Typography>
					</ExpansionPanelSummary>
					
					<FundMembers />

				</ExpansionPanel>

				{ !isAgent &&
					<ExpansionPanel expanded={this.state.expanded === 'contributions'} onChange={this.handleChange('contributions')}>
						<ExpansionPanelSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="contributions-content"
							id="contributions-header"
						>
							<Typography className={ classes.heading }>Contributions</Typography>
						</ExpansionPanelSummary>
						
						<FundContributions member_id={member_id} />

					</ExpansionPanel>
				}

				<ExpansionPanel expanded={this.state.expanded === 'reports'} onChange={this.handleChange('reports')}>
					<ExpansionPanelSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="reports-content"
						id="reports-header"
					>
						<Typography className={ classes.heading }>Reports</Typography>
					</ExpansionPanelSummary>
					
					<FundReports />

				</ExpansionPanel>

				
				<ExpansionPanel expanded={this.state.expanded === 'documents'} onChange={this.handleChange('documents')}>
					<ExpansionPanelSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="documents-content"
						id="documents-header"
					>
						<Typography className={ classes.heading }>Documents</Typography>
					</ExpansionPanelSummary>
					<ExpansionPanelDetails>
						
						<div className={ classes.root }>
							{ documentListData.length > 0 ?
								<FileBrowser document_tree={documentListData} envelope={docusignDocuments} member_id={member_id} />
							:
								<Typography>No documents found</Typography>
							}
							
						</div>

					</ExpansionPanelDetails>
				</ExpansionPanel>

				{ !isAgent &&
					<ExpansionPanel expanded={this.state.expanded === 'billing'} onChange={this.handleChange('billing')}>
						<ExpansionPanelSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="billing-content"
							id="billing-header"
						>
							<Typography className={ classes.heading }>Billing</Typography>
						</ExpansionPanelSummary>
						
						<FundBilling member_id={member_id} />

					</ExpansionPanel>
				}

			</div>
		)
	}
}

// define the prop types
Fund.propTypes = {
	classes: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    setFundId: PropTypes.func.isRequired,
    documentListData: PropTypes.array,
    fundDetailedAssetPosition: PropTypes.array,
    isFundCashReconciliationLoading: PropTypes.bool,
    fundCashReconciliationData: PropTypes.array,
	getFundSummary: PropTypes.func.isRequired,
	fundsSummaryData: PropTypes.object,
	docusignDocuments: PropTypes.array,
}

const mapStateToPros = (state) => {
    return {        
        isLoading: state.fundState.isLoading,       
        documentListData: state.documentsState.documentListData,
        fundDetailedAssetPosition: state.fundState.fundDetailedAssetPosition,
        isFundCashReconciliationLoading: state.fundState.isFundCashReconciliationLoading,
        fundCashReconciliationData: state.fundState.fundCashReconciliationData,
		fundSummary: state.fundState.fundSummary,
		fundsSummaryData: state.fundsSummaryState.fundsSummaryData,
		docusignDocuments: state.documentsState.docusignDocuments,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getFundOverallPosition: action.getFundOverallPosition,
        getDocumentsData: action.getDocumentsData,
        deleteDocument: action.deleteDocument,
        getFundCashReconciliation: action.getFundCashReconciliation,
        requestBusinessEvents: action.requestBusinessEvents,
        requestCorporateActions: action.requestCorporateActions,
        setFundId: action.setFundId,
		getFundSummary: action.getFundSummary,
		getDocusignData: action.getDocusignData,
    }
}


export default connect(mapStateToPros,mapDispatchToProps)(withStyles(styles)(Fund))


// WEBPACK FOOTER //
// ./src/components/Fund/index.js